import { z } from 'zod';

export const ConnectionTypeSchema = z.enum([
  'managedApi',
  'serviceProvider',
  'function',
  'agent',
  'mcp',
  'builtIn',
]);

export type ConnectionType = z.infer<typeof ConnectionTypeSchema>;

export const AuthenticationTypeSchema = z.enum([
  'OAuth2',
  'ConnectionString',
  'ManagedIdentity',
  'ApiKey',
]);

export type AuthenticationType = z.infer<typeof AuthenticationTypeSchema>;

export const ConnectionStatusSchema = z.enum([
  'Connected',
  'Error',
  'Warning',
  'Unknown',
]);

export type ConnectionStatus = z.infer<typeof ConnectionStatusSchema>;

export const ConnectionDetailsSchema = z.object({
  name: z.string(),
  displayName: z.string().optional(),
  connectorName: z.string(),
  type: ConnectionTypeSchema,
  status: ConnectionStatusSchema,
  authenticationType: AuthenticationTypeSchema,
  lastUpdated: z.string().optional(),
});

export type ConnectionDetails = z.infer<typeof ConnectionDetailsSchema>;

export const ConnectorManifestSchema = z.object({
  id: z.string(),
  name: z.string(),
  displayName: z.string(),
  description: z.string().optional(),
  iconUri: z.string(),
  brandColor: z.string(),
});

export type ConnectorManifest = z.infer<typeof ConnectorManifestSchema>;

export const LinkedWorkflowSchema = z.object({
  name: z.string(),
  path: z.string(),
});

export type LinkedWorkflow = z.infer<typeof LinkedWorkflowSchema>;

/**
 * Connector info for rendering workflow nodes
 */
export const NodeConnectorInfoSchema = z.object({
  displayName: z.string(),
  iconUri: z.string().optional(),
  brandColor: z.string().optional(),
  connectorType: ConnectionTypeSchema,
});

export type NodeConnectorInfo = z.infer<typeof NodeConnectorInfoSchema>;

/**
 * Service provider connection structure from connections.json
 */
export const ServiceProviderConnectionSchema = z.object({
  displayName: z.string().optional(),
  parameterSetName: z.string().optional(),
  parameterValues: z.record(z.unknown()).optional(),
  serviceProvider: z.object({
    id: z.string(), // e.g., "/serviceProviders/AzureBlob"
  }),
});

export type ServiceProviderConnection = z.infer<typeof ServiceProviderConnectionSchema>;
